import Vue from 'vue';
import Router from 'vue-router';

import CalculateTabsBri from '../views/CalculateTabsBri.vue';
import CalculatePopup from '../views/CalculatePopup.vue';

import IBooking from '../views/IBooking.vue';
import PhotoBooth from "@/views/PhotoBooth.vue";

Vue.use(Router);

const routes = [

  {
    path: '/',
    name: 'calculate bri',
    component: CalculateTabsBri,
  },
  {
    path: '/popup/:value',
    name: 'calculate popup',
    props: true,
    component: CalculatePopup,
  },

  {
    path: '/ibooking/projectId/:projectId',
    name: 'ibooking',
    props: true,
    component: IBooking,
  },
  {
    path: "/photo-booth",
    name: 'PhotoBooth',
    props: true,
    component: PhotoBooth,
  }

];

const router = new Router({
  mode: 'history',
  routes,
});

export default router;
